import { z } from 'zod';
/**
 * Neutral server-host contract used by optional business modules to contribute
 * immutable resource scopes to a Customer Portal access link. Platform owns
 * only the envelope; each provider owns the resource and grant vocabulary.
 */
export const platformPortalAccessScopeProviderHostCapability = 'platform.portal-access-scope-provider-host.v1';
export const platformPortalAccessScopeProviderSlot = 'platform.server.portal-access-scopes';
const moduleIdSchema = z.string().regex(/^[a-z][a-z0-9-]*$/);
const grantSchema = z.string().regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+$/);
const resourceTypeSchema = z.string().regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+$/);
export const platformPortalAccessScopeProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('customer-portal'),
    projectId: z.string().uuid(),
});
export const platformPortalAccessScopedResourceSchema = z.strictObject({
    resourceType: resourceTypeSchema,
    resourceId: z.string().uuid(),
    version: z.string().trim().min(1).max(160).nullable(),
});
export const platformPortalAccessScopeBundleSchema = z.strictObject({
    contractVersion: z.literal(platformPortalAccessScopeProviderHostCapability),
    providerModuleId: moduleIdSchema,
    projectId: z.string().uuid(),
    grants: z.array(grantSchema).min(1).max(20),
    resources: z.array(platformPortalAccessScopedResourceSchema).min(1).max(200),
}).superRefine((bundle, context) => {
    if (new Set(bundle.grants).size !== bundle.grants.length) {
        context.addIssue({ code: 'custom', path: ['grants'], message: 'Portal grants must be unique.' });
    }
    const identities = bundle.resources.map(({ resourceType, resourceId }) => `${resourceType}:${resourceId}`);
    if (new Set(identities).size !== identities.length) {
        context.addIssue({ code: 'custom', path: ['resources'], message: 'Portal resources must be unique.' });
    }
});
//# sourceMappingURL=platform-portal-access-scope-provider-host.contract.js.map